import { IStorageArInvoiceSummary } from './i-storagearinvoicesummary.interface';

import { BusinessObject } from '../../shared/business-object.model';
import { ArInvoiceType } from 'app/shared/arInvoiceType.model';

export class StorageArInvoiceSummary extends BusinessObject implements IStorageArInvoiceSummary {
	billToType: ArInvoiceType;
	id: number;
	invoiceNumber: string;
	postedDate?: Date = null;
	dueDate?: Date;
	glPostingDate: Date;
	emailedDate: Date;
	total: number;
	leaseNumber: string;
	payeeCode: string;
	payeeName: string;
	numberCars: number;
	get Type(): string {
		return this.invoiceNumber.startsWith('STO') ? 'Owner' : 'Customer';
		}
	intacctTotal: number;
	selected: boolean;
	hasError: boolean;
	isPosted: boolean = this.postedDate? true: false;
	accountingSystemDocId: string;
	railcarMark : string;
	railcarMarkWithoutSpace : string;
	
	constructor(storageArInvoiceSummary: StorageArInvoiceSummary) {
		super(storageArInvoiceSummary);
		this.railcarMarkWithoutSpace = this.railcarMark.replace(' ', '');
	}
}